module.exports = __webpack_public_path__ + "static/img/pc.e9f8e20.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cn/国际高中/pc.svg
// module id = a2kj
// module chunks = 16